// extracted by mini-css-extract-plugin
export var bottom = "index-module--bottom--4ac31";
export var bottomRight = "index-module--bottomRight--578ee";
export var companyLogo = "index-module--companyLogo--1b97d";
export var companyLogoLink = "index-module--companyLogoLink--2b2db";
export var copywrite = "index-module--copywrite--50815";
export var logoRow = "index-module--logoRow--d56e8";
export var wrapper = "index-module--wrapper--cbba3";